import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Endpoints } from "../../repository/Endpoints";
import { GetMaker, PostMaker } from "../../repository/RequestMaker";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useHistory } from "react-router-dom";
import { Language } from "./Language"

import "./MaterialList.css"; // Import the updated CSS file

const MaterialList = () => {
  const { trainingId } = useParams();
  const history = useHistory();
  const [mandatoryMaterials, setMandatoryMaterials] = useState([]);
  const [optionalMaterials, setOptionalMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const language = localStorage.getItem("language");

  const serialize = (sections) => {
    console.log('sections , ', sections);
    var materialsAll = [];
    const materials = sections.data; // access the data array directly
  
    for (let i = 0; i < materials.length; i++) {
      const material = materials[i];
      materialsAll.push(material);
    }
  
    // Filter out a specific material by ID
    materialsAll = materialsAll.filter(
      (m) => m.id !== "be9c4a11-57e2-48cf-a6db-1a4d76942878"
    );
  
    // Save materials in localStorage
    localStorage.setItem("material", JSON.stringify(materialsAll));
    localStorage.setItem("material_length", materialsAll.length);
    localStorage.setItem("current_material", 0);
  };
  

  // Fetch materials when the page loads
  useEffect(() => {
    if (trainingId) {
      const endpoint = Endpoints.get_materials(trainingId);
      GetMaker(endpoint).then((res) => {
        if (res && res.data) {
          // Separate mandatory and optional materials
          const mandatory = res.data.filter((material) => material.optional === 0);
          const optional = res.data.filter((material) => material.optional === 1);

          setMandatoryMaterials(mandatory);
          setOptionalMaterials(optional);
          setLoading(false);
        } else {
          console.error("Failed to fetch materials");
        }
      });
    }
  }, [trainingId]);

  // Handle drag-and-drop between the lists
// Handle drag-and-drop between the lists
const onDragEnd = (result) => {
  const { source, destination } = result;

  if (!destination) return; // Dropped outside any droppable area

  // If the source and destination are the same, reorder within the same list
  if (source.droppableId === destination.droppableId) {
    if (source.droppableId === "mandatory") {
      const reorderedItems = Array.from(mandatoryMaterials);
      const [movedItem] = reorderedItems.splice(source.index, 1);
      reorderedItems.splice(destination.index, 0, movedItem);
      setMandatoryMaterials(reorderedItems);
    } else if (source.droppableId === "optional") {
      const reorderedItems = Array.from(optionalMaterials);
      const [movedItem] = reorderedItems.splice(source.index, 1);
      reorderedItems.splice(destination.index, 0, movedItem);
      setOptionalMaterials(reorderedItems);
    }
  } else {
    // Handle moving items between mandatory and optional lists
    if (source.droppableId === "optional" && destination.droppableId === "mandatory") {
      const movedItem = optionalMaterials[source.index];
      setMandatoryMaterials([...mandatoryMaterials, movedItem]);
      setOptionalMaterials(optionalMaterials.filter((_, idx) => idx !== source.index));
    } else if (source.droppableId === "mandatory" && destination.droppableId === "optional") {
      const movedItem = mandatoryMaterials[source.index];
      if (movedItem.optional === 1) { // Only optional materials can be moved back
        setOptionalMaterials([...optionalMaterials, movedItem]);
        setMandatoryMaterials(mandatoryMaterials.filter((_, idx) => idx !== source.index));
      }
    }
  }
};


  // Handle checkbox click to move optional materials back to optional
  const handleCheckboxClick = (material) => {
    if (material.optional === 1) {
      // Move the item back to optional if it's unchecked in the mandatory block
      setOptionalMaterials([...optionalMaterials, material]);
      setMandatoryMaterials(mandatoryMaterials.filter((m) => m.id !== material.id));
    }
  };

  // Handle "Next" button click to send reordered mandatory modules to the backend
  
const handleNextClick = () => {
  const payload = {
    modules: [
      ...mandatoryMaterials.map((material, index) => ({
        id: material.id,
        lft: index,
        is_checked: true, // Since these are in the "mandatory" list, mark as checked
      })),
      ...optionalMaterials.map((material, index) => ({
        id: material.id,
        lft: index + mandatoryMaterials.length, // Continue lft numbering after mandatory items
        is_checked: false, // Optional items are unchecked
      })),
    ],
  };
// Extract and save checked material IDs in localStorage
  const checkedMaterialIds = mandatoryMaterials.map(material => material.id);
  localStorage.setItem("checkedMaterialIds", JSON.stringify(checkedMaterialIds));

  console.log("Checked Material IDs saved to localStorage:", checkedMaterialIds);
  console.log("Payload to be sent:", payload); // Log the payload for debugging

  // Use PostMaker to send the POST request
  PostMaker(payload, Endpoints.reorder_materials)
    .then((data) => {
      console.log("Reorder successful", data);
      serialize(data); // Assuming serialize still needs to be called for other logic
      history.push({
        pathname: "/trainer",
      });
      // Handle success (e.g., navigate to another page or show a success message)
    })
    .catch((error) => {
      console.error("Error:", error);
      // Handle error (e.g., show an error message)
    });
};


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bg-mine">
      <div className="material-list">
        <h1 className="text-title-color" id="title_text"     style={{
              textAlign: "left"
                  }}>            
        {Language[language].module_selection}
        </h1>
        <p       
        style={{
              textAlign: "left"
                  }}>
          
        {Language[language].select_modules_message}
        </p>
        <br/>

        {/* Drag-and-drop context */}
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="module-container">
            {/* Mandatory Modules */}
            <Droppable droppableId="mandatory">
              {(provided) => (
                <div className="module-block mandatory" ref={provided.innerRef} {...provided.droppableProps}>
                  <h2>        
                    {Language[language].mandatory_modules}
                  </h2>
                  {mandatoryMaterials.map((material, index) => (
                    <Draggable
                      key={material.id}
                      draggableId={material.id}
                      index={index}
                      //isDragDisabled={material.optional === 0} // Disable drag for mandatory materials
                    >
                      {(provided) => (
                        <div
                          className="module-item"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <input
                            type="checkbox"
                            checked
                            data-type={material.optional === 1 ? "optional" : "mandatory"}
                            className={material.optional === 0 ? "mandatory-checkbox" : "optional-checkbox"}
                            onChange={() => handleCheckboxClick(material)}
                            disabled={material.optional === 0} // Disable unchecking for mandatory materials
                          />{" "}
                          {material.name}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

            {/* Optional Modules */}
            <Droppable droppableId="optional">
              {(provided) => (
                <div className="module-block optional" ref={provided.innerRef} {...provided.droppableProps}>
                  <h2>                    
                    {Language[language].optional_modules}
                  </h2>
                  {optionalMaterials.map((material, index) => (
                    <Draggable key={material.id} draggableId={material.id} index={index}>
                      {(provided) => (
                        <div
                          className="module-item"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <input
                            type="checkbox"
                            data-type={material.optional === 1 ? "optional" : "mandatory"}
                            className={material.optional === 1 ? "optional-checkbox" : "mandatory-checkbox"}
                            onChange={() => {
                              setMandatoryMaterials([...mandatoryMaterials, material]);
                              setOptionalMaterials(optionalMaterials.filter((m) => m.id !== material.id));
                            }}
                          />{" "}
                          {material.name}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        </DragDropContext>

        {/* Next Button */}
        <br/>
      <button
                className="styled-button"
                id="next_button"
                onClick={handleNextClick}
              >
                        {Language[language].button_next_2}
                &nbsp;
                <i className="fa fa-forward icon-border" aria-hidden="true"></i>
              </button>
      </div>
    </div>
  );
};

export default MaterialList;
